import React, { FunctionComponent } from 'react'

import { ActivityView } from './ActivityView'
import { IProps } from './IProps'
import { MenuView } from './MenuView'

export const AddActivityViewSwitch: FunctionComponent<IProps> = ({
  selectViewOpen,
  setSelectViewOpen,
  selectedActivityArray,
  setSelectedActivityArray,
  defaultPersonUuids,
  activityList,
  personList,
}) => {
  switch (selectViewOpen) {
    case 'menu':
      return (
        <MenuView
          isMenuViewOpen={selectViewOpen === 'menu'}
          closeMenuView={setSelectViewOpen}
          selectedActivityArray={selectedActivityArray}
          setSelectedActivityArray={setSelectedActivityArray}
          defaultPersonUuids={defaultPersonUuids}
          activityList={activityList}
          personList={personList}
        />
      )
    case 'activity':
      return (
        <ActivityView
          isActivityViewOpen={selectViewOpen === 'activity'}
          setActivityView={setSelectViewOpen}
          selectedActivityArray={selectedActivityArray}
          setSelectedActivityArray={setSelectedActivityArray}
          defaultPersonUuids={defaultPersonUuids}
          activityList={activityList}
          personList={personList}
        />
      )
    default:
      return null
  }
}
